import { createStore } from 'vuex'
import transcriptions from '@/store/modules/transcriptions'
import wordCounts from '@/store/modules/word-counts'
import suggestions from '@/store/modules/suggestions'
import auth from '@/store/modules/auth'
import profile from '@/store/modules/profile'
import { AuthState, ProfileState, TranscriptionsState, WordCountsState, SuggestionsState } from '@/models/models'

export interface RootState {
  auth: AuthState;
  profile: ProfileState;
  transcriptions: TranscriptionsState;
  wordCounts: WordCountsState;
  suggestions: SuggestionsState;
}

export default createStore<RootState>({
  modules: {
    auth,
    profile,
    transcriptions,
    wordCounts,
    suggestions,
  }
});
